import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { VipTaskTypesEnum } from '@shared/constants';

import { useCreateVipTaskMutation } from '@services';

import { AppDispatch, setVipTask } from '@store';

import { VipTaskForm, VipTaskFormValues, VIP_TASK_FORM_INITIAL_VALUES } from '../../VipSettingsForms';

import { VipTaskCreateModalProps } from './types';

export const VipTaskCreateModal: FC<VipTaskCreateModalProps> = ({ isOpened, handleClose }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [createVipTask, { isLoading: isCreatingInProgress }] = useCreateVipTaskMutation();

  const handleCreateBetEvent = async ({ link, promoCode, ymId, casinoName, ...values }: VipTaskFormValues) => {
    const { type } = values;

    const createdVipTask = await createVipTask({
      ...values,
      link: type === VipTaskTypesEnum.PARTNER ? link : undefined,
      promoCode: type === VipTaskTypesEnum.PARTNER ? promoCode : undefined,
      ymId: type === VipTaskTypesEnum.PARTNER ? ymId : undefined,
      casinoName: type === VipTaskTypesEnum.PARTNER ? casinoName : undefined,
    }).unwrap();

    dispatch(setVipTask(createdVipTask));

    toast.success('Success: Vip task has been created!');

    handleClose();
  };

  return (
    <BaseModal headerTitle="Create VIP task" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <VipTaskForm
        initialValues={VIP_TASK_FORM_INITIAL_VALUES}
        isSubmitting={isCreatingInProgress}
        onSubmit={handleCreateBetEvent}
      />
    </BaseModal>
  );
};
